/**
 * Menu from API. Empty array = intentionally no items (not fallback).
 * Fallback only while CMS not loaded yet.
 *
 * @param {import('@/types/cms').GrvExport | null | undefined} cms
 * @param {'primary' | 'services' | 'navigation' | 'regions'} key
 * @param {{ label: string, href: string }[]} fallback
 */
export function getNavMenuItems(cms, key, fallback) {
  if (!cms?.nav_menus) {
    return fallback;
  }
  return cms.nav_menus[key] ?? fallback;
}

/**
 * @param {string} [path]
 */
export function normalizeNavPath(path = '') {
  let p = String(path || '/')
    .split('?')[0]
    .split('#')[0]
    .trim();
  if (!p) return '/';
  if (!p.startsWith('/')) p = `/${p}`;
  if (p.length > 1) p = p.replace(/\/+$/, '');
  return p || '/';
}

/**
 * @param {string} [pathname]
 * @param {string} [href]
 */
export function isNavItemActive(pathname, href) {
  const current = normalizeNavPath(pathname);
  const target = normalizeNavPath(href);
  if (target === '/') return current === '/';
  return current === target || current.startsWith(`${target}/`);
}

const DEFAULT_HEADER_CTA = { label: 'Консультація', href: '/contacts' };

/**
 * Header CTA button from Menus admin (`nav_menus.header_cta`).
 * @param {import('@/types/cms').GrvExport | null | undefined} cms
 * @returns {{ label: string, href: string } | null}
 */
export function getHeaderCta(cms) {
  if (!cms?.nav_menus) {
    return DEFAULT_HEADER_CTA;
  }
  const raw = cms.nav_menus.header_cta;
  // Missing key (old API) → default. Explicit empty label/href → hide.
  if (raw === undefined || raw === null) {
    return DEFAULT_HEADER_CTA;
  }
  if (typeof raw !== 'object') {
    return DEFAULT_HEADER_CTA;
  }
  const label = String(raw.label || '').trim();
  const href = String(raw.href || '').trim();
  if (!label || !href) {
    return null;
  }
  return { label, href };
}
